import { get, post } from "@/api/common/request";

/**
 * 发送登录短信验证码
 * GET /auth/sms/send
 */
export function sendLoginSmsCode(params) {
  return get("/auth/sms/send", params, {
    meta: { isToken: false, noApiPrefix: true },
  });
}

/**
 * 短信验证码登录
 * POST /auth/sms/login
 */
export function smsLogin(data) {
  return post("/auth/sms/login", data, {
    meta: { isToken: false, noApiPrefix: true },
  });
}

/**
 * 获取面试邀请信息
 * GET /auth/interview?token=xxx
 */
export function getInterviewDetail(token) {
  return get(
    "/auth/interview",
    { token: token },
    {
    meta: { isToken: false, noApiPrefix: true },
  });
}

/**
 * 声纹上传
 * POST /candidate/voiceprint
 * form-data: file, interview_id, duration_seconds
 */
export function uploadVoiceprint(file, interviewId, durationSeconds = 0) {
  if (!file) {
    throw new Error("uploadVoiceprint: file is required");
  }
  const formData = new FormData();
  // 按 swagger 示例：字段名固定为 file
  formData.append("file", file);
  formData.append("interview_id", String(interviewId || ""));
  formData.append("duration_seconds", String(durationSeconds));

  return post("/candidate/voiceprint", formData, {
    headers: {
      "Content-Type": "multipart/form-data;charset=utf-8",
    },
  });
}

